/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import Moment from 'react-moment';
import NumberFormat from 'react-number-format';

import getCurrencySymbol from 'utils/getCurrencySymbol';

import styles from 'common-scss/DetailsPage.module.scss';

@translate()
@inject('assetStore')
@observer
export default class FinancialAudit extends React.Component<*> {
  render(): React.Element<*> {
    const t: Function = this.props.t;
    const financialAudit: Object = this.props.assetStore.asset.financial_audit;
    const activeUser: Object = JSON.parse(localStorage.getItem('user'));
    // Price formatting separators, checks for 1,234,567.89
    // This will need revisiting if any other formats are added
    const thousandSeparator: string = activeUser.price_format.match(/^\d+(,\d{3})*(\.\d{1,2})?$/g)
      ? ','
      : '.';
    const decimalSeparator: string = activeUser.price_format.match(/^\d+(,\d{3})*(\.\d{1,2})?$/g)
      ? '.'
      : ',';

    return (
      <div className={styles['financial-tab']}>
        <h3>{t('general:assets.labels.financial_details')}</h3>
        <table>
          <tbody>
            <tr>
              <td>
                <b>{t('general:labels.date_of_purchase')}:</b>
              </td>
              <td>
                {financialAudit.date_of_purchase ? (
                  <Moment date={financialAudit.date_of_purchase} format="MMMM DD, YYYY" />
                ) : (
                  '...'
                )}
              </td>
            </tr>
            <tr>
              <td>
                <b>{t('general:accounts.labels.number')}:</b>
              </td>
              <td>
                {financialAudit.financial_account_no ? financialAudit.financial_account_no : '...'}
              </td>
            </tr>
            <tr>
              <td>
                <b>{t('general:assets.labels.department_code')}:</b>
              </td>
              <td>{financialAudit.department_code ? financialAudit.department_code : '...'}</td>
            </tr>
            <tr>
              <td>
                <b>{t('general:assets.labels.in_service_date')}:</b>
              </td>
              <td>
                {financialAudit.in_service_date ? (
                  <Moment date={financialAudit.in_service_date} format="MMMM DD, YYYY" />
                ) : (
                  '...'
                )}
              </td>
            </tr>
            <tr>
              <td>
                <b>{t('general:assets.labels.life_cycle_period')}:</b>
              </td>
              <td>
                {financialAudit.life_cycle_period_months
                  ? financialAudit.life_cycle_period_months
                  : '...'}
              </td>
            </tr>
            <tr>
              <td>
                <b>{t('general:labels.supplier')}:</b>
              </td>
              <td>{financialAudit.supplier ? financialAudit.supplier : '...'}</td>
            </tr>
            <tr>
              <td>
                <b>{t('general:labels.po_number')}:</b>
              </td>
              <td>{financialAudit.er_po_number ? financialAudit.er_po_number : '...'}</td>
            </tr>
            <tr>
              <td>
                <b>{t('general:assets.labels.purchase_price')}:</b>
              </td>
              <td>
                {financialAudit.price ? (
                  <NumberFormat
                    value={financialAudit.price}
                    displayType="text"
                    prefix={getCurrencySymbol(financialAudit.currency, activeUser.currency)}
                    decimalScale={2}
                    thousandSeparator={thousandSeparator}
                    decimalSeparator={decimalSeparator}
                  />
                ) : (
                  '...'
                )}
              </td>
            </tr>
            <tr>
              <td>
                <b>{t('general:labels.net_book_value')}:</b>
              </td>
              <td>
                {financialAudit.net_book_value ? (
                  <NumberFormat
                    value={financialAudit.net_book_value}
                    displayType="text"
                    prefix={getCurrencySymbol(financialAudit.currency, activeUser.currency)}
                    decimalScale={2}
                    thousandSeparator={thousandSeparator}
                    decimalSeparator={decimalSeparator}
                  />
                ) : (
                  '...'
                )}
              </td>
            </tr>
            <tr>
              <td>
                <b>{t('general:labels.fair_market_value')}:</b>
              </td>
              <td>
                {financialAudit.fair_market_value ? (
                  <NumberFormat
                    value={financialAudit.fair_market_value}
                    displayType="text"
                    prefix={getCurrencySymbol('', 'dollars')}
                    decimalScale={2}
                    thousandSeparator={thousandSeparator}
                    decimalSeparator={decimalSeparator}
                  />
                ) : (
                  '...'
                )}
              </td>
            </tr>
            <tr>
              <td>
                <b>{t('general:currency')}:</b>
              </td>
              <td>
                {financialAudit.currency
                  ? `${financialAudit.currency} (${getCurrencySymbol(
                      financialAudit.currency,
                      activeUser.currency
                    )})`
                  : '...'}
              </td>
            </tr>
            <tr>
              <td>
                <b>{t('general:assets.labels.warranty_period')}:</b>
              </td>
              <td>
                {financialAudit.warranty_period_months
                  ? financialAudit.warranty_period_months
                  : '...'}
              </td>
            </tr>
            <tr>
              <td>
                <b>{t('general:assets.labels.warranty_expires')}:</b>
              </td>
              <td>
                {financialAudit.warranty_expires ? (
                  <Moment date={financialAudit.warranty_expires} format="MMMM DD, YYYY" />
                ) : (
                  '...'
                )}
              </td>
            </tr>
            <tr>
              <td>
                <b>{t('general:assets.labels.disposal_date')}:</b>
              </td>
              <td>
                {financialAudit.disposal_date ? (
                  <Moment date={financialAudit.disposal_date} format="MMMM DD, YYYY" />
                ) : (
                  '...'
                )}
              </td>
            </tr>
            <tr>
              <td>
                <b>{t('general:assets.labels.disposal_price')}:</b>
              </td>
              <td>
                {financialAudit.disposal_price ? (
                  <NumberFormat
                    value={financialAudit.net_book_value}
                    displayType="text"
                    prefix={getCurrencySymbol(
                      financialAudit.disposal_currency,
                      activeUser.currency
                    )}
                    decimalScale={2}
                    thousandSeparator={thousandSeparator}
                    decimalSeparator={decimalSeparator}
                  />
                ) : (
                  '...'
                )}
              </td>
            </tr>
            <tr>
              <td>
                <b>{t('general:assets.labels.disposal_currency')}:</b>
              </td>
              <td>
                {financialAudit.disposal_currency
                  ? `${financialAudit.disposal_currency} (${getCurrencySymbol(
                      financialAudit.disposal_currency,
                      activeUser.currency
                    )})`
                  : '...'}
              </td>
            </tr>
            <tr>
              <td>
                <b>{t('general:assets.labels.audited_by')}:</b>
              </td>
              <td>{financialAudit.audited_by ? financialAudit.audited_by : '...'}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}
